import React from 'react';
import { SubTabs } from '../diagnostic/shared.jsx';

// Comercial › Actividad e informes: the existing commercial screens together (Actividad, Resumen comercial and Precios
// cotizados), each unchanged, with its own data and rules. `views`: [key, label, element]; the menu says which one opens.
export default function ReportsHub({ tab, onTab, views }) {
  const current = views.find(v => v[0] === tab) || views[0];
  return (
    <div>
      <div className="page-content" style={{ padding: '16px 20px 0' }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1.2, textTransform: 'uppercase', color: 'var(--globant-muted)' }}>Comercial</div>
        <SubTabs tabs={views.map(v => [v[0], v[1]])} value={current[0]} onChange={onTab} />
      </div>
      {current[2]}
    </div>
  );
}
